export default {
  types: {
    all: 'Все',
    visited: 'Посещенные',
    favorites: 'Избранные'
  }
}
